import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

function scrolling_text_teaser() {
    const scrollingTeasers = document.querySelectorAll('[data-block="scrolling-text-teaser"]');
    if (!scrollingTeasers.length) { return; }
  
    scrollingTeasers.forEach(teaser => {
        const textContainer = teaser.querySelector('[data-name="marquee-container"]');
        const textElement = teaser.querySelector('[data-name="marquee-text"]');
        
        if (!textElement) return;
        
        // First ensure all existing text elements have the right spacing
        textElement.style.marginRight = '100px';
        
        // Get text width including the margin
        const textWidth = textElement.offsetWidth + 100; // Adding the margin width
        const windowWidth = window.innerWidth;
        
        // Calculate how many clones we need (at least 2, more if needed to fill screen)
        const numClones = Math.max(2, Math.ceil((windowWidth * 2) / textWidth));
        
        // Create the clones
        for (let i = 0; i < numClones; i++) {
            const clone = textElement.cloneNode(true);
            textContainer.appendChild(clone);
        }
        
        // Create a wrapper for smoother animation
        const allTexts = textContainer.querySelectorAll('[data-name="marquee-text"]');
        
        // Create the infinite scroll animation with better parameters for smoothness
        gsap.to(textContainer, {
            x: `-=${textWidth}`,  
            ease: "none",
            duration: 15, 
            repeat: -1,
            repeatRefresh: true,  
            onRepeat: () => {
                // Seamless loop: when first element moves out, reset position
                gsap.set(textContainer, { x: 0 });
            }
        });
    });
}

export { scrolling_text_teaser }; 